import React, {memo, useEffect, useState} from 'react'
import '../Styles/BenutzerProfil.css';
import {Button, Col, Container, Form, Row, Modal} from "react-bootstrap";
import {getUserInfo, isUserDataDuplicate, putUserInfo, readUserInfo} from '../API/user';
import validator from "validator/es";
import {checkPassword, getOut} from "../Utils/Common";
import PasswordRuleSetComponent from "../Components/PasswordRuleSetComponent";


/**
 * Handles the change in password in case of  duplication and saving through an API call
 */
async function setnewpwd(userInfo, setErrorMessage, setPswdErrorMessage, uid, setSuccessMessage, setAbbrechenButton) {
    setErrorMessage('');
    setPswdErrorMessage('');
    const old_pwd = userInfo.pwd;
    const new_pwd = userInfo.new_pwd;
    let messageText = await putUserInfo({uid, old_pwd, new_pwd}); //  API call
    if (messageText.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
        getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
    }
    if (messageText.message === 'Benutzereigenschaften geändert') {
        setAbbrechenButton('Ok');
        messageText = {message: 'Passwort geändert'}
    }
    if (messageText.message === 'Passwort falsch') {
        messageText = {message: 'Passwort falsch'};
        setPswdErrorMessage('Passwort falsch');
    }
    readUserInfo(messageText, setSuccessMessage);
}


/**
 * Handles the change in handynummer in case of  duplication and saving through an API call
 */

async function checkhandynr(co, uid, setCoErrorMessage, coInitvalue, setinitCo, setSuccessMessage) {
    let contactData = {"co": co};
    if (co !== coInitvalue) {
        let messageContact = await isUserDataDuplicate(1, contactData);
        if (messageContact["co"] === '') { // co is message from backend and has value if something wrong
            setinitCo(co);//
            let messageText = await putUserInfo({uid, co}); //  API call
            if (messageText.message === 'Benutzereigenschaften geändert') {
                messageText = {message: 'Handynr geändert'}
            } else if (messageText.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
            }
            readUserInfo(messageText, setSuccessMessage);
        }
        setCoErrorMessage(messageContact["co"])
    }
}

function BenutzerProfil() {
    //show and setshow states for the passwort modal
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
        setAbbrechenButton('Abbrechen');
        setSuccessMessageHandyNr('');
        setPswdErrorMessage('');
        setSuccessMessagePwd('');
        setErrorMessage('');
        setCoErrorMessage('');
        setUserInfo({
            ...userInfo,
            new_pwd: '',
            newConfirmPassword: '',
            pwd: ''
        })
    }
    const [userInfo, setUserInfo] = useState({});
    const [errorMessage, setErrorMessage] = useState('')
    const [pswderrorMessage, setPswdErrorMessage] = useState('')
    const [successMessageHandyNr, setSuccessMessageHandyNr] = useState('')
    const [successMessagePwd, setSuccessMessagePwd] = useState('')
    const [coErrorMessage, setCoErrorMessage] = useState('')
    const [coInitvalue, setinitCo] = useState('')
    const [abbrechenButton, setAbbrechenButton] = useState('Abbrechen')


    /**
     * Handles the password modal closing resetting all the messages.
     */

    const handleClose = () => {
        setShow(false);
        setPswdErrorMessage('');
        setSuccessMessagePwd('');
        setErrorMessage('');
        setSuccessMessageHandyNr('');
        setCoErrorMessage('');
        setUserInfo({
            ...userInfo,
            new_pwd: '',
            newConfirmPassword: '',
            pwd: ''
        })

    };

    /**
     * Get the data of the current user through an API call
     */
    useEffect(async () => {
        let mounted = true;
        await getUserInfo()
            .then(items => {
                if (items.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
                }
                if (mounted) {
                    items['ge'] = items.ge.gender;
                    setUserInfo(items);
                    setinitCo(items['co'])
                }
            });
        return () => mounted = false;

    }, []);


    /**
     * Validates the first password entry from user and store it.
     * @param event
     */
    const handleFirstPasswordChange = (event) => {
        setErrorMessage('');
        setPswdErrorMessage('');
        setSuccessMessageHandyNr('');
        setSuccessMessagePwd('');
        setAbbrechenButton('Abbrechen');
        setUserInfo({
            ...userInfo,
            new_pwd: event.target.value
        });
        let temppass = event.target.value;

        // Checks the password validation and animate the dots on UI
        checkPassword(temppass)
    };


    /**
     * Validates the second password entry from user and store it.
     * @param event
     */
    const handleSecondPasswordChange = (event) => {
        setErrorMessage('');
        setSuccessMessageHandyNr('');
        setSuccessMessagePwd('');
        setAbbrechenButton('Abbrechen');
        setPswdErrorMessage('');

        setUserInfo({
            ...userInfo,
            newConfirmPassword: event.target.value
        })

        let secondpass = event.target.value;

        if (secondpass === userInfo.new_pwd && secondpass !== '') {
            setErrorMessage('');
            document.getElementById("c5").checked = true;
        } else {
            document.getElementById("c5").checked = false;
        }
    }

    /**
     * Submits the handynummer form .
     * @param event
     */

    const handleHandySubmit = (e) => {
        e.preventDefault();
        setErrorMessage('');
        setPswdErrorMessage('');
        setSuccessMessageHandyNr('');
        setSuccessMessagePwd('');

        const uid = userInfo.uid;
        const co = userInfo.co;

        if (validator.isNumeric(co)) {
            checkhandynr(co, uid, setCoErrorMessage, coInitvalue, setinitCo, setSuccessMessageHandyNr);
        } else {
            setCoErrorMessage('Bitte eine gültige Handynummer eintragen')
        }
    };

    /**
     * Checks the change in password for old password, as well as the rules followed in new password.
     * @param event
     */
    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        setErrorMessage('');
        setPswdErrorMessage('');
        setSuccessMessageHandyNr('');
        setSuccessMessagePwd('');

        const uid = userInfo.uid;

        if (userInfo.pwd !== undefined && checkPassword(userInfo.new_pwd)) {
            setnewpwd(userInfo, setErrorMessage, setPswdErrorMessage, uid, setSuccessMessagePwd, setAbbrechenButton);
        } else {
            setErrorMessage('Bitte Regeln beachten');
        }
    };

    return (
        <div>
            <br/>
            <Container fluid>
                <div className="row handwai-dark handwai-text-label-normal" style={borerStyle}>
                    <div className="col-1"/>
                    <div id="benutzer-profil-form" className="col-10">
                        <br/>
                        <Form onSubmit={handleHandySubmit}>
                            <Form.Group as={Row} controlId="formPlaintextGeschlecht">
                                <Form.Label column sm="2">
                                    Geschlecht
                                </Form.Label>
                                <Col sm="2">
                                    <Form.Control readOnly defaultValue={userInfo.ge}/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextVorname">
                                <Form.Label column sm="2">
                                    Vorname
                                </Form.Label>
                                <Col sm="7">
                                    <Form.Control readOnly defaultValue={userInfo.fn}/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextNachname">
                                <Form.Label column sm="2">
                                    Nachname
                                </Form.Label>
                                <Col sm="7">
                                    <Form.Control readOnly defaultValue={userInfo.ln}/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">
                                    E-Mail
                                </Form.Label>
                                <Col sm="7">
                                    <Form.Control readOnly defaultValue={userInfo.em}/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextHandyNummer">
                                <Form.Label column sm="2">
                                    Handynr
                                </Form.Label>
                                <Col sm="7">
                                    <Form.Control
                                        className="handwai-input"
                                        defaultValue={userInfo.co}
                                        onChange={event => setUserInfo({
                                            ...userInfo,
                                            co: event.target.value
                                        })}/>

                                    <span style={{
                                        fontWeight: 'normal',
                                        color: 'lightgreen',
                                    }}>{successMessageHandyNr}</span>

                                    <span style={{
                                        fontWeight: 'bold',
                                        color: 'red',
                                    }}>{coErrorMessage}</span>
                                </Col>
                            </Form.Group>
                            <br/>

                            <Col>
                                <Row>
                                    <Button className="handwai-btn-create"
                                            onClick={handleShow} size="lg">
                                        Passwort
                                    </Button>
                                </Row>
                            </Col>

                            <br/><br/><br/>

                            <Row>
                                <Col>
                                    <Button className="handwai-btn-pdfdownload" type={"submit"}
                                            size="lg">Speichern</Button>
                                    {
                                        ' '
                                    }
                                </Col>
                            </Row>
                        </Form>
                        <br/><br/><br/><br/>
                        <br/><br/>
                        <br/>
                        <div className="col-1"/>
                    </div>

                    {/*Passwort Andern Modal*/}
                    <Form onSubmit={handlePasswordSubmit}>
                        <Modal show={show}
                               onHide={handleClose}
                               backdrop="static"
                               keyboard={false}
                               size="xl"
                               centered
                               className="passwordChangeModal"
                        >
                            <Modal.Body className={"handwai-dark handwai-text-label-normal"}>
                                <Row>
                                    <Col>
                                        <p className="handwai-text-label-main">Passwort ändern</p>
                                        <Form.Group as={Row} controlId="formPlaintextOldPassword">
                                            <Form.Label column sm="4">
                                                Altes Passwort
                                            </Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="password" className="handwai-input" placeholder=""
                                                              maxlength="50"
                                                              onChange={event => setUserInfo({
                                                                  ...userInfo,
                                                                  pwd: event.target.value
                                                              })}
                                                />
                                                <span style={{
                                                    fontWeight: 'bold',
                                                    color: 'red',
                                                }}>{pswderrorMessage}</span>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} controlId="formPlaintextNewPassword1">
                                            <Form.Label column sm="4">
                                                Neues Passwort
                                            </Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="password" className="handwai-input" placeholder=""
                                                              maxlength="50"
                                                              onChange={handleFirstPasswordChange}
                                                />
                                                <span style={{
                                                    fontWeight: 'bold',
                                                    color: 'red',
                                                }}>{errorMessage}</span>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} controlId="formPlaintextNewPassword2">
                                            <Form.Label column sm="4">
                                                Neues Passwort
                                            </Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="password" className="handwai-input" placeholder=""
                                                              maxlength="50"
                                                              onChange={handleSecondPasswordChange}/>
                                                <span style={{
                                                    fontWeight: 'bold',
                                                    color: 'red',
                                                }}>{errorMessage}</span>
                                            </Col>
                                        </Form.Group>
                                        <span style={{
                                            fontWeight: 'normal',
                                            color: 'lightgreen',
                                        }}>{successMessagePwd}</span>
                                        <br/>
                                    </Col>
                                    <PasswordRuleSetComponent/>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer className={"handwai-dark handwai-text-label-normal"}>
                                <Col className={'text-center'}>
                                    <Button className="passwortModalbutton handwai-btn-pdfdownload"
                                            variant="outline-success" onClick={handlePasswordSubmit} type={"submit"}>
                                        Ändern
                                    </Button>
                                </Col>
                                <Col className={'text-center'}>
                                    <Button className="passwortModalbutton handwai-btn-create"
                                            variant="outline-dark" onClick={handleClose}>
                                        {abbrechenButton}
                                    </Button>
                                </Col>
                            </Modal.Footer>
                        </Modal>
                    </Form>
                </div>
            </Container>
        </div>
    )
        ;
}

const borerStyle = {
    margin: 20,
    padding: 20,
    paddingBottom: 50,
    color: "white"
}


export default memo(BenutzerProfil);